<script lang="ts" setup>
import CLink from '@clovyr/bed/components/elements/CLink.vue';

const props = defineProps<{ label: string; slug: string }>();

const linkToPath = computed(() => {
  if (props.slug) {
    return `/tag/${props.slug}`;
  }
  return '/';
});
</script>

<template>
  <c-link :to="linkToPath" :label="label" class="tag" />
</template>

<style lang="scss" scoped>
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';
@use 'styles/core/layout/grid-vars';
@use 'styles/core/typography/fonts';
@use 'styles/core/util';

.tag {
  display: inline-block;
  padding: grid-vars.space(1) grid-vars.space(2) grid-vars.space(1);
  margin: grid-vars.space(0.5) grid-vars.space(0.5);
  color: colors.color(grey, tertiary);
  cursor: pointer;
  background-color: colors.color(background);

  @include util.borders-convex;
  @include fonts.font-size(12);

  &:hover {
    background-color: colors.color(grey);
  }
}
</style>
